import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { red, green, grey } from '@mui/material/colors';

const useProductIndicatorStyles = makeStyles(theme => ({
  root: {
    fontSize: 16,
  },
  icon: {
    fontSize: 20,
    width: 25,
    height: 25,
    boxShadow: '0 2px 2px 2px rgba(155, 155, 155, 0.3)',
    borderRadius: '50%',
    padding: 5,
    marginRight: 10,
  },
  iconAvailable: {
    color: green[500],
  },
  iconUnavailable: {
    color: red[500],
  },
  iconUpgrade: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
  name: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  nameUnavailable: {
    color: grey[500],
    fontSize: 14,
    marginTop: 3,
  },
}));

const ShopProductIndicator = ({ product }) => {
  const classes = useProductIndicatorStyles();

  const IconComponent = product.availability ? CheckIcon : CloseIcon;

  return (
    <Grid container className={classes.root}>
      <Grid item>
        <IconComponent
          className={clsx({
            [classes.icon]: true,
            [classes.iconAvailable]: product.availability,
            [classes.iconUnavailable]: !product.availability,
            [classes.iconUpgrade]: product.upgrade,
          })}
        />
      </Grid>
      <Grid item>
        <Typography
          className={clsx({
            [classes.name]: true,
            [classes.nameUnavailable]: !product.availability,
          })}
        >
          {product.type}
        </Typography>
      </Grid>
    </Grid>
  );
};

ShopProductIndicator.propTypes = {
  product: PropTypes.shape({
    type: PropTypes.string.isRequired,
    availability: PropTypes.bool.isRequired,
    upgrade: PropTypes.bool.isRequired,
  }).isRequired,
};

export { ShopProductIndicator };
